
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "1b414f7a016f79f6b42da51fbc78f539d03bafd6",
  "nuxt": {
    "buildId": "0a34e390-7875-4b9d-bfa1-cca4311b89cb"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
